import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthUser } from '@core/models/auth-user.model';
import { ErrorMessages } from '@shared/models/error-messages.model';

import { AuthService } from '@core/auth/auth.service';
import { finalize } from 'rxjs/operators';

const INITIAL_PAGE_ERRORS: ErrorMessages = {
  messages: []
};
@Component({
  selector: 'fdx-login-page',
  templateUrl: './login-page.component.html',
  host: {
    class: 'd-flex align-items-center h-100 animated fadeIn slow'
  }
})
export class LoginPageComponent {
  isLoading: boolean = false;
  responseErrors: ErrorMessages = INITIAL_PAGE_ERRORS;

  constructor(private authService: AuthService, private router: Router) {}

  onSubmitForm(user: AuthUser): void {
    this.initializeRequest();

    this.authService
      .login(user)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (result: boolean) => {
          this.navigateToAuthLayout(result);
        },
        (error: HttpErrorResponse) => (this.responseErrors = error.error)
      );
  }

  private navigateToAuthLayout(navigate: boolean): void {
    if (navigate) {
      this.router.navigate(['/home']);
    }
  }

  private initializeRequest(): void {
    this.isLoading = true;
    this.responseErrors = INITIAL_PAGE_ERRORS;
  }
}
